import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { INewsletterSubscriptionStatus } from '@curbnturf/objects';
import { BASE_API_URL } from '../network/api-config';

const NEWSLETTER_API_URL = BASE_API_URL + 'notification-settings/newsletter';

/**
 * Local, plain-HttpClient port of @curbnturf/user's UserMarketingService
 * .registerForNewsletter() — same public POST {BASE_API_URL}notification-settings/newsletter
 * endpoint, without that service's CachedHttpClient/NgRx dependency. Only
 * the subscribe path is ported; getStatus/updateSubscription/
 * removeNewsletterSubscription aren't used from marketing pages.
 */
@Injectable({ providedIn: 'root' })
export class NewsletterApiService {
  private readonly http = inject(HttpClient);

  subscribe(subscriber: { email: string; firstName?: string; lastName?: string }): Observable<INewsletterSubscriptionStatus> {
    return this.http.post<INewsletterSubscriptionStatus>(NEWSLETTER_API_URL, subscriber);
  }
}
